import React, { useEffect, useRef } from 'react';
import "../Section4/Section4.css";
import img1 from "../../../assets/icon1.png";
import img2 from "../../../assets/icon2.png";
import img3 from "../../../assets/icon3.png";
import img4 from "../../../assets/icon4.png";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

export default function Section4() {
    const sectionRef = useRef(null);
    const cardRefs = useRef([]);

    useEffect(() => {
        // Animate each card when it comes into view
        cardRefs.current.forEach((card, index) => {
            if(index<2){
                gsap.fromTo(
                    card,
                    {
                        opacity : 0,
                        x : -400
                    },
                    {
                        opacity : 1,
                        x : 0,
                        delay : 0.2,
                        scrollTrigger : {
                            trigger : card,
                            start : "top 70%",
                            end : "top 40%",
                            ease: 'power2.out',
                            toggleActions: "play none none reverse",
                        },

                    }
                )
            }
            else{
                gsap.fromTo(
                    card,
                    {
                        opacity : 0,
                        x : 400
                    },
                    {
                        opacity : 1,
                        x : 0,
                        delay : 0.2,
                        scrollTrigger : {
                            trigger : card,
                            start : "top 70%",
                            end : "top 40%",
                            toggleActions: "play none none reverse", 
                        },

                    }
                )

            }
 
        });

    }, []);

    const data = [
        {
            img: img1,
            title: "TECH SAVVY HOTEL",
            description: "Elevate your hotel's experience with cutting-edge technology",
        },
        {
            img: img2,
            title: "TASK MANAGEMENT",
            description: "Simplify daily operations with seamless automation.",
        },
        {
            img: img4,
            title: "OPTIMIZED STAFFING",
            description: "Ensure the right staff at the right time with smart resource allocation.",
        },
        {
            img: img3,
            title: "DATA-DRIVEN INSIGHTS",
            description: "Make informed decisions with actionable analytics at your fingertips.",
        },
    ];

    return (
        <div className='py-8 lg:px-12 px-4 w-full overflow-hidden' ref={sectionRef}>
            <div className='section4-home'>
                {data.map((item, index) => (
                    <div
                        className='elem'
                        key={index}
                        ref={(el) => (cardRefs.current[index] = el)}
                    >
                        <div className='elem-side1'>
                            <h3 className='font-bold'>{item.title}</h3>
                            <h4 className='mt-2 text-gray-400'>{item.description}</h4>
                        </div>
                        <div className='elem-side2'>
                            <img src={item.img} alt="Error" title={item.title} />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}